/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThermoformingInsoleStock } from '../../models/thermoforming-insole-stock';
import { UpdateThermoformingInsoleStockDto } from '../../models/update-thermoforming-insole-stock-dto';

export interface UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params {
  id: number;
      body: UpdateThermoformingInsoleStockDto
}

export function updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock$Params, context?: HttpContext): Observable<StrictHttpResponse<ThermoformingInsoleStock>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThermoformingInsoleStock>;
    })
  );
}

updateOneBaseMgmtThermoformingInsoleStockControllerThermoformingInsoleStock.PATH = '/api/mgmt/thermoforming-insole-stock/{id}';
